/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CountryDisciplineTeamEvent,
    CountryDisciplineTeamEventFromJSON,
    CountryDisciplineTeamEventToJSON,
    IndividualEvent,
    IndividualEventFromJSON,
    IndividualEventToJSON,
    TeamEvent,
    TeamEventFromJSON,
    TeamEventToJSON,
} from '../models';

export interface ApiEventAthleteGetRequest {
    accreditationNumber?: string;
}

export interface ApiEventCdGetRequest {
    accreditationNumber?: string;
}

export interface ApiEventTeamGetRequest {
    accreditationNumber?: string;
}

/**
 * 
 */
export class EventApi extends runtime.BaseAPI {

    /**
     */
    async apiEventAthleteGetRaw(requestParameters: ApiEventAthleteGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<IndividualEvent>>> {
        const queryParameters: any = {};

        if (requestParameters.accreditationNumber !== undefined) {
            queryParameters['accreditationNumber'] = requestParameters.accreditationNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Event/athlete`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IndividualEventFromJSON));
    }

    /**
     */
    async apiEventAthleteGet(requestParameters: ApiEventAthleteGetRequest, initOverrides?: RequestInit): Promise<Array<IndividualEvent>> {
        const response = await this.apiEventAthleteGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEventCdGetRaw(requestParameters: ApiEventCdGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CountryDisciplineTeamEvent>>> {
        const queryParameters: any = {};

        if (requestParameters.accreditationNumber !== undefined) {
            queryParameters['accreditationNumber'] = requestParameters.accreditationNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Event/cd`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryDisciplineTeamEventFromJSON));
    }

    /**
     */
    async apiEventCdGet(requestParameters: ApiEventCdGetRequest, initOverrides?: RequestInit): Promise<Array<CountryDisciplineTeamEvent>> {
        const response = await this.apiEventCdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEventTeamGetRaw(requestParameters: ApiEventTeamGetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<TeamEvent>>> {
        const queryParameters: any = {};

        if (requestParameters.accreditationNumber !== undefined) {
            queryParameters['accreditationNumber'] = requestParameters.accreditationNumber;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Event/team`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TeamEventFromJSON));
    }

    /**
     */
    async apiEventTeamGet(requestParameters: ApiEventTeamGetRequest, initOverrides?: RequestInit): Promise<Array<TeamEvent>> {
        const response = await this.apiEventTeamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
